import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { Loader2, ShieldAlert, Wrench } from 'lucide-react';

export default function AdminBypassPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setAdminSession } = useAuth();
  const [status, setStatus] = useState('logging_in');
  const [error, setError] = useState('');

  useEffect(() => {
    const k = params.get('k') || params.get('key');
    if (!k) {
      setStatus('error');
      setError('Missing bypass key. Use the full bookmark URL.');
      return;
    }
    (async () => {
      try {
        const res = await api.post('/auth/admin-bypass', { key: k });
        setAdminSession(res.data.token, res.data.user);
        setStatus('success');
        // Small delay so user sees the confirmation
        setTimeout(() => navigate('/admin/sponsor', { replace: true }), 500);
      } catch (e) {
        setStatus('error');
        setError(e.response?.data?.detail || 'Bypass failed. Check your key.');
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 grid-bg">
      <div className="max-w-md w-full">
        {status === 'logging_in' && (
          <div className="industrial-card border-t-4 border-t-amber-400 text-center py-12">
            <Loader2 size={40} className="text-amber-400 animate-spin mx-auto mb-4" />
            <div className="font-display text-2xl text-zinc-100 tracking-wide">SIGNING YOU IN…</div>
            <div className="text-zinc-500 font-mono text-xs uppercase tracking-widest mt-2">One-tap admin access</div>
          </div>
        )}
        {status === 'success' && (
          <div className="industrial-card border-t-4 border-t-lime-400 text-center py-12">
            <Wrench size={40} className="text-lime-400 mx-auto mb-4" />
            <div className="font-display text-2xl text-zinc-100 tracking-wide">YOU'RE IN.</div>
            <div className="text-zinc-500 font-mono text-xs uppercase tracking-widest mt-2">Redirecting to dashboard…</div>
          </div>
        )}
        {status === 'error' && (
          <div className="industrial-card border-t-4 border-t-red-500 text-center py-12">
            <ShieldAlert size={40} className="text-red-500 mx-auto mb-4" />
            <div className="font-display text-2xl text-zinc-100 tracking-wide">ACCESS DENIED</div>
            <div className="text-zinc-400 mt-2">{error}</div>
            <button
              onClick={() => navigate('/')}
              className="btn-secondary mt-6 text-sm"
            >
              Back to Home
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
